import React from 'react';
import Navbar from '../ShareComponents/Navbar/Navbar';
import Blogs from '../HomePage/Blogs/Blogs'

const BlogPage = () => {
    return (
        <div>
            <Navbar />
            <Blogs />
        </div>
    );
};

export default BlogPage;